import { useRef } from "react";
import { IPermissionProps } from "../../models/Login";
import { InvoiceTable } from "./Table";
import { Toast } from "primereact/toast";

interface IProps {
    permissions: IPermissionProps
}

export const PendingPaymentInvoices = (props: IProps) => {
    const toast = useRef<any>(null);
    return (
        <>
            <InvoiceTable permissions={props.permissions} toast={toast} po={{}} />
            <Toast ref={toast} />
        </>
    );
}